import PresetPills from "./PresetPills";
import RoleSwitch from "./RoleSwitch";
import SavedViewsMenu from "./SavedViewsMenu";
import AdvancedFilterButton from "./AdvancedFilterButton";

/**
 * Unified filter bar combining role switch + preset pills + advanced filters.
 * Replaces the old NavItems which exposed 5 separate popup filters.
 */
const FilterBar = ({
  // Role + preset
  role,
  onRoleChange,
  activePresetId,
  onApplyPreset,
  shopId,
  staffId,
  accountId,
  pipelineStages = [],
  // Saved views
  currentFilterSnapshot,
  onApplyView,
  // Advanced filter props (forwarded to SidebarFilters for now)
  tags,
  tagZalos,
  managers,
  selectedTags,
  selectedTagZalos,
  selectedManagers,
  selectedCategories,
  selectedPipelineStageIds,
  needsReplyMinutes,
  newCustomerDays,
  hasContactInfo,
  upcomingBirthdayDays,
  onTagsChange,
  onTagZalosChange,
  onManagersChange,
  onCategoriesChange,
  onPipelineStagesChange,
  onNeedsReplyMinutesChange,
  onNewCustomerDaysChange,
  onHasContactInfoChange,
  onUpcomingBirthdayDaysChange,
  sortMode,
  onSortModeChange,
}) => {
  return (
    <div className="flex flex-row items-center gap-2 min-w-0 flex-1">
      <div className="shrink-0">
        <RoleSwitch role={role} onChange={onRoleChange} />
      </div>

      <div className="flex-1 min-w-0 overflow-hidden">
        <PresetPills
          role={role}
          activePresetId={activePresetId}
          shopId={shopId}
          staffId={staffId}
          pipelineStages={pipelineStages}
          onApplyPreset={onApplyPreset}
        />
      </div>

      <div className="flex items-center gap-1.5 shrink-0">
      <AdvancedFilterButton
        tags={tags}
        tagZalos={tagZalos}
        managers={managers}
        pipelineStages={pipelineStages}
        selectedTags={selectedTags}
        selectedTagZalos={selectedTagZalos}
        selectedManagers={selectedManagers}
        selectedCategories={selectedCategories}
        selectedPipelineStageIds={selectedPipelineStageIds}
        needsReplyMinutes={needsReplyMinutes}
        newCustomerDays={newCustomerDays}
        hasContactInfo={hasContactInfo}
        upcomingBirthdayDays={upcomingBirthdayDays}
        onTagsChange={onTagsChange}
        onTagZalosChange={onTagZalosChange}
        onManagersChange={onManagersChange}
        onCategoriesChange={onCategoriesChange}
        onPipelineStagesChange={onPipelineStagesChange}
        onNeedsReplyMinutesChange={onNeedsReplyMinutesChange}
        onNewCustomerDaysChange={onNewCustomerDaysChange}
        onHasContactInfoChange={onHasContactInfoChange}
        onUpcomingBirthdayDaysChange={onUpcomingBirthdayDaysChange}
        sortMode={sortMode}
        onSortModeChange={onSortModeChange}
      />

      <SavedViewsMenu
        staffId={staffId}
        accountId={accountId}
        role={role}
        currentFilterSnapshot={currentFilterSnapshot}
        onApplyView={onApplyView}
      />
      </div>
    </div>
  );
};

export default FilterBar;
